export default __webpack_public_path__ + "static/top-6dbed56acc65ff25f67f74570ede3b6f.png";